import React from 'react'
import PropTypes from 'prop-types'
import AccessedItemRow from './AcessedItemRow'
import camelize from 'camelize'

const AccessedItemsList = props => {
  let accessedItemRows = camelize(props.items).map((item, idx) => (
    <AccessedItemRow item={item} key={idx} />
  ))

  return <div className='AccessedItemsList'>{accessedItemRows}</div>
}

AccessedItemsList.propTypes = {
  items: PropTypes.array
}

export default AccessedItemsList
